var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShow)?_c('div',{staticClass:"fixed inset-x-0",staticStyle:{"top":"0","height":"5px"}},[_c('div',{staticClass:"absolute inset-y-0 left-0 bg-primary",style:({width: Math.round(_vm.done/_vm.total*100) + '%' })})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }